import './styles/App.css';
import properties from './properties.json' with { type: 'json' };
import { Intro } from './modules/Intro';
import { Asistencia } from './modules/Asistencia.tsx';
import {Timeline} from './modules/Timeline';
import {NavBar} from './modules/NavBar';
import {Regalos} from './modules/Regalos';
import {PhotoGallery} from './modules/PhotoGallery'
import {HeroImageBackground} from './modules/HeroPortada.tsx'
import {Cronologia} from './modules/Cronologia.tsx'
import { SaveTheDate } from './modules/SaveTheDate.js';
function App() {
  return (
    <div className="App">
      {Intro('Fer & Jaime', properties.introWordList)}
      {HeroImageBackground()}
      {NavBar('Feb 6, 2027 18:30:00')}
      {Timeline()}
      {Asistencia()}
      {PhotoGallery()}
      {Regalos()}
      {Cronologia()} 
      {SaveTheDate()}
    </div>
  );
}

export default App;
